$(function () {
  const $iframe = $('#plusQueProIframe');
  if ($iframe.length) {
    $iframe.on('load', function () {
      try {
        const h = $(this).contents().find('html').height();
        if (h) $(this).css('height', h);
      } catch (e) {}
    });
  }
});
